export const CSAT_ABM = {
  PROD: '337',
  QA: '406'
};
export const CSAT_SUBMISSIONS = {
  PROD: '763',
  QA: '408'
};
export const CAST_FORM_ROUTING = {
  PROD: '968',
  QA: '407'
};